// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1479":"1780751a","2069":"78239e74","7892":"1780751a"}[chunkId] + ".chunk.css";
};